import { render } from "./MultiSelectControl.vue?vue&type=template&id=5edf4162"
import script from "./MultiSelectControl.vue?vue&type=script&lang=js"
export * from "./MultiSelectControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MultiSelectControl.vue"]])

export default __exports__